import React from 'react'

function Download() {
    const HeadingStyle={
        fontSize: '5rem',
        fontWeight: 'bold',
        color: '#6C727B',

        textAlign: "center"
      }
  return (
    <div>
        <h2 style={HeadingStyle}>Download FlashFeed from Play Store</h2>
   
        <br/>
        <br/>
        <button type="button" class="btn btn-light" style={{backgroundColor:"white", borderRadius:"20px", width:"14rem", fontWeight:"bold"}}>Download Now</button>
        <br/>
        <br/>
        <br/>






    </div>
  )
}

export default Download